import { isDevMode } from '@angular/core';

const PREFIX = '[Hostex]:';

export const log = (...args: any[]) => {
  if (isDevMode()) {
    console.log(PREFIX, ...args);
  }
};